import { useState } from "react";
import { isSoundOn, setSoundOn } from "../sound";
import { tapFeedback } from "../feedback";

/** Sound on or off for this device only; each phone in the house chooses for itself. */
export function SoundToggle() {
  const [on, setOn] = useState(isSoundOn);

  function toggle() {
    const next = !on;
    setSoundOn(next);
    setOn(next);
    // Turning it on answers with a tick, which also proves the speaker works.
    if (next) tapFeedback();
  }

  // Same row and switch as the Notifications section, so the two settings look like one family.
  return (
    <div className="list__item notify">
      <span className="notify__label" id="sound-toggle">
        Sounds on taps and stars
      </span>
      <button
        className="switch"
        type="button"
        role="switch"
        aria-checked={on}
        aria-labelledby="sound-toggle"
        onClick={toggle}
      >
        <span className="switch__thumb" aria-hidden="true" />
      </button>
    </div>
  );
}
